import { CoachMatchingSuccessScreen } from '@/components/CoachMatchingSuccessScreen';

export default function CoachMatchingSuccess() {
  return <CoachMatchingSuccessScreen />;
}
